export type DiagramDecisionGateProps = {
  x: number;
  y: number;
  label?: string;
};

export function DiagramDecisionGate({
  x,
  y,
  label = "VALID?",
}: DiagramDecisionGateProps) {
  return (
    <g transform={`translate(${x}, ${y})`}>
      <polygon
        points="38,0 76,20 38,40 0,20"
        fill="var(--ga-paper-strong, #ffffff)"
        stroke="currentColor"
        strokeWidth="1.4"
        opacity="0.9"
      />
      <text
        x="38"
        y="20"
        textAnchor="middle"
        dominantBaseline="middle"
        fill="currentColor"
        className="text-[12px] font-mono font-bold tracking-wider"
      >
        {label}
      </text>
    </g>
  );
}
